function init() {
    const saleContainer = document.querySelector('.js-sale-notifications-container');
    const notification = document.querySelector('.js-sale-notification');
    if (saleContainer && notification) {
        const notificationCloseButtons = notification.querySelectorAll('.js-sale-notification-close-btn');
        requestAnimationFrame(() => {
            setTimeout(() => {
                notification.classList.remove('hidden-start');
            }, 0);
        });

        const handleNotificationClose = () => {
            notification.classList.add('closed');

            setTimeout(() => {
                saleContainer.remove();

                notificationCloseButtons.forEach((button) => {
                    button.removeEventListener('click', handleNotificationClose);
                });

                document.removeEventListener('click', handleNotificationClose);
            }, 400);
        };

        notificationCloseButtons.forEach((button) => {
            button.addEventListener('click', handleNotificationClose);
        });

        document.addEventListener('click', handleNotificationClose);
    }
}

const _module = { init };

export default _module;
